import React, { useEffect, useRef } from 'react'
import phoneMockup from "../../Assets/sec.png";

import Svg1 from "../../Assets/features-1.svg";
import Svg2 from "../../Assets/features-2.svg";
import Svg3 from "../../Assets/features-3.svg";
import 'aos/dist/aos.css';

const Tile = ({ icon, heading, text, alt, _style }) => {
  return (
    <div className={`max-w-[400px] h-full bg-slate-300 dark:bg-[#222A32] w-full rounded-xl p-4 text-center dark:text-white flex flex-col justify-start ${_style} flex flex-col justify-center items-center`} data-aos="fade-left" data-aos-delay="400">
      <div className=''>
        <h3 className="text-[18px] font-bold mb-2">{heading}</h3>
        <div className="flex justify-center items-center mb-3">
          <img src={icon} alt={alt} width={30} height={30} loading="lazy" />
        </div>
        <p className="text-[14px] leading-relaxed">
          {text}
        </p>
      </div>
    </div>
  );
};


function FeaturesSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const sectionTop = sectionRef.current.offsetTop;
      const sectionHeight = sectionRef.current.offsetHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const viewportHeight = window.innerHeight;
      const opacity = Math.min(1, 1.9 * (scrollTop - sectionTop + viewportHeight) / sectionHeight);
      if (sectionRef.current) {
        sectionRef.current.style.opacity = opacity;
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div id="help" className=" px-6 py-10 md:px-16 mx-auto mt-28 overflow-hidden">
      <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Text Content */}
        <div>
          <div className="ml-1 flex items-center justify-start gap-[6px] mb-3">
            <div className="h-[6px] w-5 bg-[#00E6C2]"></div>
            <div className="h-[6px] w-11 bg-[#00E6C2]"></div>
          </div>
          <h2 className="text-[32px] md:text-[40px] font-bold text-[#111920] dark:text-white leading-[46px]">
            How can<span className='bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA]'>IzzyAI</span>  help you <br /> improve your speaking <span className='bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA]'>skills</span>?
          </h2>
          <p className="mt-6 text-[16px] md:text-[17px] text-black dark:text-[#d1d5db]">
            Our AI-driven therapy provides personalized exercises and feedback, helping you to speak more fluently. Break free from stammering with technology that understands and adapts to your pace.
          </p>
        </div>

        {/* Right Grid of Cards */}
        <div className="2xl:grid xl:grid lg:grid md:grid flex flex-col grid-cols-1 sm:grid-cols-2 gap-6 relative auto-rows-fr  mb-2">
          <div className={`max-w-[400px] h-full bg-slate-300 dark:bg-[#222A32] w-full rounded-xl p-4 text-center dark:text-white  flex flex-col justify-center items-center`} data-aos="fade-left" data-aos-delay="400">
            <div className=''>
              <h3 className="text-[18px] font-bold mb-4">Assessment</h3>
              <div className="flex justify-center items-center mb-4">
                <img src={Svg3} alt={"IzzyAI Assessment"} width={30} height={30} loading="lazy" className='scale-150' />
              </div>
              <p className="text-[14px] leading-relaxed">
                Begin your journey with IzzyAI’s comprehensive assessment, powered by advanced AI models. These initial evaluations accurately identify your speech patterns, pinpointing areas for improvement. This tailored approach ensures that you receive the most effective therapy right from the start.
              </p>
            </div>
          </div>
          <div className={`2xl:mt-10 xl:mt-10 lg:mt-10 md:mt-10 max-w-[400px] h-full bg-slate-300 dark:bg-[#222A32] w-full rounded-xl p-4 text-center dark:text-white  flex flex-col justify-center items-center`} data-aos="fade-left" data-aos-delay="400">
            <div className=''>
              <h3 className="text-[18px] font-bold mb-4">Exercises</h3>
              <div className="flex justify-center items-center mb-4">
                <img src={Svg2} alt="IzzyAI Exercises" width={30} height={30} loading="lazy" className='scale-150' />
              </div>
              <p className="text-[14px] leading-relaxed">
                Start your journey with IzzyAI’s AI-powered assessment, identifying speech patterns and areas for improvement for effective therapy from day one.              </p>
            </div>
          </div>
          <div className={` max-w-[400px] h-full bg-slate-300 dark:bg-[#222A32] w-full rounded-xl p-4 text-center dark:text-white  flex flex-col justify-center items-center`} data-aos="fade-left" data-aos-delay="400">
            <div className=''>
              <h3 className="text-[18px] font-bold mb-4">Reports</h3>
              <div className="flex justify-center items-center mb-4">
                <img src={Svg1} alt="IzzyAI Reports" width={30} height={30} loading="lazy" className='scale-150' />
              </div>
              <p className="text-[14px] leading-relaxed">
                Start your journey with IzzyAI’s AI-powered assessment, identifying speech patterns and areas for improvement for effective therapy from day one.
              </p>
            </div>
          </div>
          <div className={`2xl:mt-10 xl:mt-10 lg:mt-10 md:mt-10 max-w-[400px] 2xl:h-full  xl:h-full lg:h-full md:h-full bg-slate-300 dark:bg-[#222A32] w-full rounded-xl p-4 text-center dark:text-white flex flex-col justify-center items-center`} data-aos="fade-left" data-aos-delay="400">
            <div className=''>
              <h3 className="text-[18px] font-bold mb-4">Support</h3>
              <div className="flex justify-center items-center mb-4">
                <img src={Svg1} alt={"IzzyAI Support"} width={30} height={30} loading="lazy" className='scale-150' />
              </div>
              <p className="text-[14px] leading-relaxed">
                Start your journey with IzzyAI’s AI-powered assessment, identifying speech patterns and areas for improvement for effective therapy from day one.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default FeaturesSection;
